import { render, staticRenderFns } from "./BackInStockForm.vue?vue&type=template&id=5cca7cd5&scoped=true&"
import script from "./BackInStockForm.vue?vue&type=script&lang=js&"
export * from "./BackInStockForm.vue?vue&type=script&lang=js&"
import style0 from "./BackInStockForm.vue?vue&type=style&index=0&id=5cca7cd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cca7cd5",
  null
  
)

export default component.exports